var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXlsx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5848_9742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.48971V18.8848C5 19.8425 5.76951 20.6189 6.71875 20.6189H18.2812C19.2305 20.6189 20 19.8425 20 18.8848V5.31874C20 4.85553 19.8163 4.41157 19.4899 4.08583L16.6549 1.2568C16.3331 0.935707 15.8988 0.755615 15.4463 0.755615H6.71875C5.76951 0.755615 5 1.532 5 2.48971ZM6.09375 18.8848V2.48971C6.09375 2.14145 6.37357 1.85913 6.71875 1.85913H15.2344V5.6426C15.2344 6.29559 15.759 6.82494 16.4062 6.82494H18.9062V18.8848C18.9062 19.233 18.6264 19.5153 18.2812 19.5153H6.71875C6.37357 19.5153 6.09375 19.233 6.09375 18.8848ZM18.9062 5.72143V5.31874C18.9062 5.1503 18.8395 4.98886 18.7208 4.87041L16.3281 2.48281V5.6426C16.3281 5.68614 16.3631 5.72143 16.4062 5.72143H18.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8125 8.90263C12.8125 8.60267 13.0573 8.3595 13.3594 8.3595H16.9531C17.2552 8.3595 17.5 8.60267 17.5 8.90263C17.5 9.2026 17.2552 9.44577 16.9531 9.44577H13.3594C13.0573 9.44577 12.8125 9.2026 12.8125 8.90263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8125 11.3855C12.8125 11.0856 13.0573 10.8424 13.3594 10.8424H16.9531C17.2552 10.8424 17.5 11.0856 17.5 11.3855C17.5 11.6855 17.2552 11.9287 16.9531 11.9287H13.3594C13.0573 11.9287 12.8125 11.6855 12.8125 11.3855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8125 13.8685C12.8125 13.5685 13.0573 13.3253 13.3594 13.3253H16.9531C17.2552 13.3253 17.5 13.5685 17.5 13.8685C17.5 14.1684 17.2552 14.4116 16.9531 14.4116H13.3594C13.0573 14.4116 12.8125 14.1684 12.8125 13.8685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.49731C0 5.98309 0.419733 5.56622 0.9375 5.56622H10.3125C10.8303 5.56622 11.25 5.98309 11.25 6.49731V15.8082C11.25 16.3224 10.8303 16.7393 10.3125 16.7393H0.9375C0.419733 16.7393 0 16.3224 0 15.8082V6.49731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 13.6667L4.8381 11.0754L3.16995 8.70087H4.44007L5.51789 10.2963L6.57335 8.70087H7.83005L6.1619 11.1126L8 13.6667H6.68962L5.49553 11.9493L4.30143 13.6667H3Z",
    fill: "#1F1F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5848_9742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.8632,
    fill: "white",
    transform: "translate(0 0.755615)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.dd545b7f.svg";
export { ForwardRef as ReactComponent };